module.exports = __webpack_public_path__ + "img/total_installed_capacity_per_year.3b6e248e.png";